import { FaSignOutAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "../../hooks/useIsMobile";
import { TOKEN_KEY } from "../../constants/storageKey";

export function LogoutButton() {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  function handleLogout() {
    localStorage.removeItem(TOKEN_KEY);
    navigate("/login");
  }
  return (
    <button
      className={`border-2 rounded-lg 
        bg-primary-danger hover:bg-secondary-danger 
        px-2 min-w-32 lg:px-4 lg:py-3 lg:min-w-44 
        text-sm lg:text-lg  
        flex justify-center justify-self-center ${
          isMobile ? "py-2" : "min-w-20 py-4"
        }`}
      onClick={handleLogout}
      aria-label="Deconnexion"
      role="menuitem"
    >
      <FaSignOutAlt className={`${isMobile ? "hidden" : ""} text-white`} />
      <span className={`${isMobile ? "" : "hidden"} text-white`}>
        Deconnexion
      </span>
    </button>
  );
}
